module.exports = __webpack_public_path__ + "img/offline-tips.5f88096f.png";